export const USER_GROUPS = {
  ADMIN: "Admin",
  PRODUCTION: "production",
  OFFICE: "office",
  ACCOUNTING: "accounting",
  QUALITY_MANAGEMENT: "qualitymanagement",
  LOGISTICS: "logistics",
};

export const GLOBAL_SETTINGS_ID = "goldweisswebglobalsettings";

export const SHIPPING_METHOD_SERVICE_PROVIDER_FREI_HAUS =
  "222fac1f-b577-4eb1-aa56-bd81a6f0f506";

export const SHIPPING_METHOD_SERVICE_PROVIDER_AB_WERK =
  "1934a321-efc3-4295-a8fa-b49342a9c4f5";

export const MATERIAL_TYPE_ZINK = "1b3dfb8b-60b8-4a1b-98dc-e8cae89cd9b3";

export const ZINK_Z410 = "a0a07452-688f-4fbd-9d9e-c18f8a97aa1f";
export const ZINK_Z430 = "61622168-1c2a-4bb8-9054-2a56500a9103";

export const MASCHINE_DAW_125_I = "06f72684-9aa4-4906-80af-e2ffe4dd5eb3";
export const MASCHINE_DAW_125_II = "b868f86a-5106-40df-8059-0ed2ab2c9575";
export const MASCHINE_DAW_80_I = "0697f914-d2fd-4863-9895-af14dbf681d7";
export const MASCHINE_DAW_80_II = "4608077d-ecae-4439-8f25-2ae290b99720";
export const MASCHINE_DAW_50 = "47ed58ed-bc9b-4f7a-bfa7-c387a478f2a6";
export const MASCHINE_DAW_20 = "996413aa-d0ee-48cf-a5d2-2dd469bcfafa";

export const FUSOR_PACKAGING_SCHAEFER = "a348772e-70c7-4c8c-9bec-18c754d046e0";

export const WAREHOUSE_VERSANDLAGER_SUBUNTERNEHMEN =
  "e70d2b85-0538-4f4d-8b63-668a993e5b71";

export const WAREHOUSE_VERSANDLAGER_FERTIGTEILE =
  "c500482e-8f15-4262-8b76-ac7ecb74efdf";

export const WAREHOUSE_GUSSLAGER = "420bf0b7-22b8-42c8-80b7-b66648045a9b";

export const EMPLOYEE_POSITIONTYPE_BEARBEITUNG =
  "6c90ec52-3d2f-4c7e-974e-9b9a2fd2cdb6";

export const USER_GROUPS_OPTIONS = [
  {
    value: "Admin",
    label: "Admin",
  },
  {
    value: "management",
    label: "Management",
  },
  {
    value: "office",
    label: "Büro",
  },
  {
    value: "accounting",
    label: "Buchhaltung",
  },
];

export const SALUTATION_OPTIONS = [
  {
    value: "Mrs",
    label: "Frau",
  },
  {
    value: "Mr",
    label: "Herr",
  },
];

export const OPENING_HOURS = [
  {
    value: "00:00",
    label: "00:00",
  },
  {
    value: "00:30",
    label: "00:30",
  },
  {
    value: "01:00",
    label: "01:00",
  },
  {
    value: "01:30",
    label: "01:30",
  },
  {
    value: "02:00",
    label: "02:00",
  },
  {
    value: "02:30",
    label: "02:30",
  },
  {
    value: "03:00",
    label: "03:00",
  },
  {
    value: "03:30",
    label: "03:30",
  },
  {
    value: "04:00",
    label: "04:00",
  },
  {
    value: "04:30",
    label: "04:30",
  },
  {
    value: "05:00",
    label: "05:00",
  },
  {
    value: "05:30",
    label: "05:30",
  },
  {
    value: "06:00",
    label: "06:00",
  },
  {
    value: "06:30",
    label: "06:30",
  },
  {
    value: "07:00",
    label: "07:00",
  },
  {
    value: "07:30",
    label: "07:30",
  },
  {
    value: "08:00",
    label: "08:00",
  },
  {
    value: "08:30",
    label: "08:30",
  },
  {
    value: "09:00",
    label: "09:00",
  },
  {
    value: "09:30",
    label: "09:30",
  },
  {
    value: "10:00",
    label: "10:00",
  },
  {
    value: "10:30",
    label: "10:30",
  },
  {
    value: "11:00",
    label: "11:00",
  },
  {
    value: "11:30",
    label: "11:30",
  },
  {
    value: "12:00",
    label: "12:00",
  },
  {
    value: "12:30",
    label: "12:30",
  },
  {
    value: "13:00",
    label: "13:00",
  },
  {
    value: "13:30",
    label: "13:30",
  },
  {
    value: "14:00",
    label: "14:00",
  },
  {
    value: "14:30",
    label: "14:30",
  },
  {
    value: "15:00",
    label: "15:00",
  },
  {
    value: "15:30",
    label: "15:30",
  },
  {
    value: "16:00",
    label: "16:00",
  },
  {
    value: "16:30",
    label: "16:30",
  },
  {
    value: "17:00",
    label: "17:00",
  },
  {
    value: "17:30",
    label: "17:30",
  },
  {
    value: "18:00",
    label: "18:00",
  },
  {
    value: "18:30",
    label: "18:30",
  },
  {
    value: "19:00",
    label: "19:00",
  },
  {
    value: "19:30",
    label: "19:30",
  },
  {
    value: "20:00",
    label: "20:00",
  },
  {
    value: "20:30",
    label: "20:30",
  },
  {
    value: "21:00",
    label: "21:00",
  },
  {
    value: "21:30",
    label: "21:30",
  },
  {
    value: "22:00",
    label: "22:00",
  },
  {
    value: "22:30",
    label: "22:30",
  },
  {
    value: "23:00",
    label: "23:00",
  },
  {
    value: "23:30",
    label: "23:30",
  },
];

export const WEIGHT_OPTIONS = [
  { value: "t", label: "Tonne (t)" },
  { value: "kg", label: "Kilogramm (kg)" },
  { value: "g", label: "Gramm (g)" },
  { value: "mg", label: "Milligramm (mg)" },
];
